<template>
    <Dialog :header="$t('invite') + ' ' + roleLabel"
            :visible.sync="displayModal"
            :style="{width: '35vw'}"
            :closable="false"
            :modal="true"
            @keyup.esc="close">

        <div v-if="role && role === 'Guest'" class="p-grid" style="margin-bottom: 1em;">
            <div class="p-col-6">
                <RadioButton id="emailRadioButton" name="accountCreationOption" value="email" v-model="selectedOption"/>
                <label for="emailRadioButton" class="p-radiobutton-label">{{ $t("viaEmail") }}</label>
            </div>
            <div class="p-col-6">
                <RadioButton id="newAccountRadioButton" name="accountCreationOption" value="newAccount"
                             v-model="selectedOption"/>
                <label for="newAccountRadioButton" class="p-radiobutton-label">{{ $t("createGuestAccount") }}</label>
            </div>
        </div>

        <div v-if="selectedOption === 'email'">
            <p>
                <i>
                  {{ $t("emailInvitationWillBeSent")}}
                </i>
            </p>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon pi pi-envelope"></span>
                <InputText name="email" type="email" v-model="email" @keyup.enter="invite"/>
            </div>
        </div>
        <div v-else>
            <p>
                <i>
                  {{ $t("guestAccountWillBeCreated") }}
                </i>
            </p>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <span class="p-float-label">
                        <InputText id="name" type="text" v-model="name"/>
                        <label for="name">{{ $t("name") }}</label>
                    </span>
                </div>
                <div class="p-col-12">
                    <span class="p-float-label">
                        <InputText id="username" type="text" v-model="username"/>
                        <label for="username">{{ $t("username") }}</label>
                    </span>
                </div>
                <div class="p-col-12">
                    <span class="p-float-label">
                        <InputText id="password" type="password" v-model="password"/>
                        <label for="password">{{ $t("password") }}</label>
                    </span>
                </div>
                <div class="p-col-12">
                    <span class="p-float-label">
                        <InputText id="passwordConfirmation" type="password"
                                   v-model="passwordConfirmation"/>
                        <label for="passwordConfirmation">{{ $t("confirmPassword") }}</label>
                    </span>
                </div>
            </div>
            <div class="p-col-12" v-for="error in errors" :key="error.code">
                <i style="color: red">{{ $t(error.code) }}</i>
            </div>
        </div>

        <template #footer>
            <Button :label="successLabel" :disabled="!isFormValid" icon="pi pi-check" @click="invite"/>
            <Button :label="$t('cancel')" icon="pi pi-times" @click="close" class="p-button-secondary"/>
        </template>

    </Dialog>
</template>

<script>
    export default {
        props: {
            displayModal: Boolean,
            role: String,
            roleLabel: String,
            errors: Array
        },
        model: {
            event: ['email-invite', 'create-guest']
        },
        data() {
            return {
                selectedOption: 'email',
                email: null,
                name: null,
                username: null,
                password: null,
                passwordConfirmation: null
            }
        },
        methods: {
            invite() {
                if (this.selectedOption === 'email') {
                    this.$emit('email-invite', this.email);
                } else if (this.selectedOption === 'newAccount') {
                    this.$emit('create-guest', {name: this.name, username: this.username, password: this.password});
                }
                this.clearForm();
            },
            close() {
                this.clearForm();
                this.$emit('update:displayModal', false);
            },
            clearForm() {
                this.selectedOption = 'email';
                this.email = '';
            },
            isValidEmail(text) {

                if (!text) {
                    return false;
                }

                const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

                return re.test(text.toLowerCase());
            }
        },
        computed: {
            successLabel() {
                if (this.selectedOption === 'email') {
                    return this.$t('invite');
                }

                if (this.selectedOption === 'newAccount') {
                    return this.$t('create');
                }

                return '????';
            },
            isFormValid() {
                if (this.selectedOption === 'email') {
                    return this.isValidEmail(this.email);
                }

                if (this.selectedOption === 'newAccount') {
                    return this.username && this.passwordConfirmed;
                }

                return false;
            },
            passwordConfirmed() {
                return this.password &&
                    this.passwordConfirmation &&
                    this.password === this.passwordConfirmation;
            }
        }
    }
</script>

<i18n lang="yaml" locale="en">
  emailInvitationWillBeSent: "An e-mail will be sent with an invitation link. If the user is not already a member of the system, an account will be created."
  invite: "Invite"
  create: "Create"
  guestAccountWillBeCreated: "A guest account will be created. It will have limited read-only functionality and won't be able to change password."
  confirmPassword: "Confirm password"
  viaEmail: "Via e-mail"
  createGuestAccount: "Create guest account"
</i18n>

<i18n lang="yaml" locale="dk">
  emailInvitationWillBeSent: "En invitation vil blive sendt via e-mail. En ny brugerkonto bliver generet, hvis medarbejderen ikke allerede er bruger."
  invite: "Inviter"
  create: "Skab"
  guestAccountWillBeCreated: "Generer en gæste-konto. Kontoen har begrænset \"read only\" adgang og kan ikke ændre adgangskode."
  confirmPassword: "Bekræft adgangskode"
  viaEmail: "Via e-mail"
  createGuestAccount: "Generer en gæste-konto"
</i18n>
